import { render } from "./YingFu.vue?vue&type=template&id=0987da28&scoped=true"
import script from "./YingFu.vue?vue&type=script&lang=js"
export * from "./YingFu.vue?vue&type=script&lang=js"

import "./YingFu.vue?vue&type=style&index=0&id=0987da28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0987da28"]])

export default __exports__